'use strict';

angular.module('sharecrf.cookies', [
    'ngCookies',
])
    .component('sharecrfCookies', {
        templateUrl: 'modules/cookies/content.html',
        controller: 'ShareCrfCookiesController',
    });
